import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

// FontAwesome "square-plus" (regular/outlined), inlined. The FA kit is in webfont (`css`) mode and
// only serves the solid 900 face, so `fa-regular` silently renders solid — same reason
// PenToSquareIcon is inlined. Inherits color via `currentColor`.
const SquarePlusIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 448 512" {...props}>
    <path d="M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z" />
  </SvgIcon>
)
export default SquarePlusIcon
